import React from 'react';

// Shown to a shared user (not the owner) when the monitor isn't on Plus.
// Sharing is a Plus feature: nothing was deleted, and access comes back as
// soon as the owner turns Plus on. The cloud also stops their alerts.
export default function SharingPaused({ ownerEmail }) {
  return (
    <div className="card sharing-paused" role="status">
      <div className="sharing-paused__title">Sharing is paused</div>
      <p className="sharing-paused__body">
        Shared access is part of SoKo Plus, and SoKo Plus isn&apos;t active on this monitor right now.
        Ask the owner{ownerEmail ? ` (${ownerEmail})` : ''} to turn on SoKo Plus to restore your access.
      </p>
      <p className="sharing-paused__note">You won&apos;t get alerts for this monitor until then.</p>
    </div>
  );
}
